import { EnvironmentFilled, HeartOutlined, HeartFilled, DeleteFilled } from '@ant-design/icons';
import { Tag, Card }                                                   from 'antd';
import React                                                           from 'react';
import { useNavigate }                                                 from 'react-router-dom';
import { deleteMyPropertiesApi }                                       from "../../modules/myProperties/apis/apis";
import NoImage                                                         from "../Assets/No_Image_Available.jpg"
import Notification                                                    from '../Notification';
import { addToFavApi, removeFavApi, }                                  from './apis/apis';

const CardComponent = ({ cardType, data, refresh, refreshState, setSavePropertyInDate, removeSavePropertyInDate }) => {
  const navigate = useNavigate()
  const saveProperty = async (id) => {
    try {
      let result = await addToFavApi({ propertyId: id })
      if (result?.status) {
        setSavePropertyInDate(result.data.data)
        Notification("success", "Property has been saved");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  const removeSaveProperty = async (id) => {
    try {
      let result = await removeFavApi(id)
      if (result?.status) {
        removeSavePropertyInDate(result.data.data)
        Notification("success", "Property has been removed from save");
      }
      else {
        Notification('error', "Error", "Error.");
      }
    }
    catch (err) {
      Notification('error', "Error", "Error.");
    }
  };

  let isLoggedIn = localStorage.getItem("token") && localStorage.getItem("userLogin");
  let userId = localStorage.getItem("userId")
  let myPhoto = cardType === "saved"
    ? (data?.property?.photos?.length > 0 ? data.property.photos[0] : NoImage)
    : (data?.photos?.length > 0 ? data.photos[0] : NoImage);

  return <Card
    style={ {
      minWidth: 240,
      maxWidth: 240,
      margin: "auto",
      marginTop: 20
    } }
    cover={
      <img
        onClick={ () => navigate(`/details/${ cardType === "saved" ? data?.propertyId : data?.id }`) }
        style={ {
          height: 180,
          objectFit: "cover",
          cursor: "pointer"
        } }
        alt="example"
        src={ myPhoto }
        onError={ (e) => {
          e.target.onerror = null;
          e.target.src = NoImage
        } }
      />
    }
  >

    <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
      { (data?.type || data?.property?.type) && <Tag style={ {
        borderRadius: 20
      } } bordered={ false } color="processing">
        { data?.type || data?.property?.type }
      </Tag> }
      <span style={ {
        color: "#1677ff",
        fontWeight: 700,
        fontSize: 16
      } }>${ data?.price || data?.property?.price }</span>
    </div>

    <h4 style={ {
      marginTop: 10
    } }>{ data?.title || data?.property?.title }</h4>
    <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
      <div>
        <EnvironmentFilled style={ { marginRight: 8, color: "#246BFD" } }/>
        <span>
  { (data?.address || data?.property?.address)?.length > 10
    ? (data?.address || data?.property?.address).slice(0, 10) + "..."
    : (data?.address || data?.property?.address) }
</span>
      </div>
      <div style={ {
        display: "flex",
        alignItems: "center",
        gap: 10
      } }>
        {
          cardType === "saved" && userId !== data?.userId &&
          <HeartFilled onClick={ () => removeSaveProperty(cardType === "saved" ? data?.propertyId : data?.id) }
                       style={ {
                         marginLeft: 8,
                         color: isLoggedIn ? "#246BFD" : 'grey',
                         fontSize: 16
                       } }/>
        }
        {
          userId === `${ data?.userId }` ? null : (cardType !== "myProperty" ?
            isLoggedIn && userId === `${ data?.favorite?.userId }` ?
              <HeartFilled onClick={ () => removeSaveProperty(data?.id) }
                           style={ { marginLeft: 8, color: isLoggedIn ? "#246BFD" : 'grey', fontSize: 16 } }/> :
              isLoggedIn && <HeartOutlined onClick={ () => saveProperty(data?.id) }
                                           style={ {
                                             marginLeft: 8,
                                             color: isLoggedIn ? "#246BFD" : 'grey',
                                             fontSize: 16
                                           } }/> : null)
        }

        {
          cardType === "myProperty" && <DeleteFilled style={ {
            fontSize: '18px',
            cursor: 'pointer',
            color: "grey"
          } } onClick={ async () => {
            const isDeleted = await deleteMyPropertiesApi(data?.id);
            console.log(isDeleted)
            if (isDeleted?.data?.success) {
              refresh(!refreshState)
              Notification('success', isDeleted?.data?.data?.message || 'Deleted Successfully.');
            }
            else {
              Notification('error', isDeleted?.response?.data?.data?.message || 'Error while deleting');
            }
          } }/>
        }

        {/*<Button onClick={ () => navigate(`/details/${ cardType === "saved" ? data?.propertyId : data?.id }`) }*/ }
        {/*        size={ "small" } type={ "primary" }>View</Button>*/ }
        {/*<Button onClick={() => addFeatureProperty(data.id)}*/ }
        {/*        size={"small"} type={"primary"}>Feature</Button>*/ }
      </div>
    </div>
  </Card>
}

export default CardComponent